/* Cart drawer behaviour.

   Everything degrades: with JavaScript off, the header cart control is still a link to
   /cart, Add to cart still posts the form and lands on /cart, and Buy now still posts and
   lands on /checkout. This file only intercepts those journeys to keep the shopper on the
   page they are already reading.

   Buy now is deliberately NOT intercepted. It carries return_to=/checkout as its submit
   value, and going straight there is the whole point of that button. */

(function () {
  'use strict';

  var panel = document.getElementById('cdPanel');
  if (!panel || !window.fetch) return;

  var scrim       = document.querySelector('[data-cd-scrim]');
  var linesEl     = panel.querySelector('[data-cd-lines]');
  var footEl      = panel.querySelector('[data-cd-foot]');
  var sumsEl      = panel.querySelector('[data-cd-sums]');
  var countEl     = panel.querySelector('[data-cd-count]');
  var liveEl      = panel.querySelector('[data-cd-live]');
  var warrantyBox = panel.querySelector('[data-cd-warranty]');
  var WARRANTY_ID = panel.getAttribute('data-warranty-id') || '';

  var lastTrigger = null;
  var busy = false;

  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])';
  var JSON_HEAD  = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

  function money(cents) {
    var n = cents / 100;
    return '$' + (n % 1 === 0 ? String(n) : n.toFixed(2));
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=128';
  }
  function say(msg) { if (liveEl) liveEl.textContent = msg; }

  /* fetch resolves on 4xx, so without this a rejected cart write looks like a success and
     the drawer just re-renders the unchanged cart with no word to the shopper */
  function ok(r) { if (!r.ok) throw new Error('cart request failed'); return r; }

  function isWarranty(item) {
    return WARRANTY_ID && String(item.variant_id) === String(WARRANTY_ID);
  }

  /* ---------------- cart requests ---------------- */

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  /* A warranty on its own is not a thing anyone can be sold, so if the last wrap leaves the
     cart the cover goes with it rather than sitting there as a lone $12 line. */
  function reconcile(cart) {
    var items = cart.items || [];
    if (!WARRANTY_ID || items.length !== 1 || !isWarranty(items[0])) return Promise.resolve(cart);
    return fetch('/cart/change.js', {
      method: 'POST', headers: JSON_HEAD,
      body: JSON.stringify({ line: 1, quantity: 0 })
    }).then(ok).then(function (r) { return r.json(); });
  }

  function refresh(message) {
    return getCart().then(reconcile).then(function (cart) {
      render(cart);
      paintBadge(cart.item_count);
      if (message) say(message);
      return cart;
    });
  }

  function paintBadge(n) {
    var nodes = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = n;
      nodes[i].hidden = !(n > 0);
      var link = nodes[i].parentNode;
      if (link && link.setAttribute) {
        link.setAttribute('aria-label', 'Cart, ' + n + (n === 1 ? ' item' : ' items'));
      }
    }
  }

  /* ---------------- rendering ---------------- */

  function render(cart) {
    var items = cart.items || [];

    countEl.textContent = items.length
      ? cart.item_count + (cart.item_count === 1 ? ' item' : ' items')
      : '';

    if (!items.length) {
      linesEl.innerHTML = '<p class="cd-empty">Nothing in here yet.</p>';
      footEl.hidden = true;
      return;
    }
    footEl.hidden = false;

    var html = '';
    items.forEach(function (it, i) {
      var line = i + 1;
      var discounts = (it.discounts || []).map(function (d) {
        return '<span class="cd-d">' + esc(d.title) + '</span>';
      }).join('');
      var variant = (it.variant_title && it.variant_title.indexOf('Default') === -1)
        ? '<span class="cd-v">' + esc(it.variant_title) + '</span>' : '';

      html +=
        '<div class="cd-line">' +
          (it.image
            ? '<img class="cd-img" src="' + esc(thumb(it.image)) + '" alt="" width="64" height="64" loading="lazy">'
            : '<span class="cd-img cd-noimg"></span>') +
          '<div class="cd-info">' +
            '<span class="cd-t">' + esc(it.product_title) + '</span>' +
            variant + discounts +
            '<div class="cd-qty">' +
              '<button type="button" data-line="' + line + '" data-q="' + (it.quantity - 1) + '"' +
                ' aria-label="Decrease quantity of ' + esc(it.product_title) + '">&minus;</button>' +
              '<span aria-hidden="true">' + it.quantity + '</span>' +
              '<button type="button" data-line="' + line + '" data-q="' + (it.quantity + 1) + '"' +
                ' aria-label="Increase quantity of ' + esc(it.product_title) + '">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="cd-p">' +
            (it.original_line_price > it.final_line_price
              ? '<s>' + money(it.original_line_price) + '</s>' : '') +
            '<strong>' + money(it.final_line_price) + '</strong>' +
            '<button type="button" class="cd-rm" data-line="' + line + '" data-q="0"' +
              ' aria-label="Remove ' + esc(it.product_title) + '">Remove</button>' +
          '</div>' +
        '</div>';
    });
    linesEl.innerHTML = html;

    var sums = '';
    if (cart.original_total_price > cart.total_price) {
      sums += '<div class="cd-r"><span>Before discounts</span><s>' + money(cart.original_total_price) + '</s></div>';
      sums += '<div class="cd-r cd-save"><span>You save</span><span>' +
              money(cart.original_total_price - cart.total_price) + '</span></div>';
    }
    sums += '<div class="cd-r tot"><span>Subtotal</span><span>' + money(cart.total_price) + '</span></div>';
    sums += '<p class="cd-note">Shipping is free inside the US. Taxes are worked out at checkout.</p>';
    sumsEl.innerHTML = sums;

    if (warrantyBox) {
      var held = items.some(isWarranty);
      warrantyBox.checked = held;
      var wrap = warrantyBox.parentNode;
      while (wrap && wrap.className.indexOf('cd-warranty') === -1) wrap = wrap.parentNode;
      if (wrap) wrap.hidden = false;
    }
  }

  /* ---------------- open / close ---------------- */

  function open(trigger) {
    lastTrigger = trigger || document.activeElement;
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('on'); }); }
    panel.classList.add('open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cd-lock');
    document.addEventListener('keydown', onKey, true);
    refresh().then(function () {
      var first = panel.querySelector(FOCUSABLE);
      if (first) first.focus();
    });
  }

  function close() {
    panel.classList.remove('open');
    panel.setAttribute('aria-hidden', 'true');
    if (scrim) {
      scrim.classList.remove('on');
      setTimeout(function () { scrim.hidden = true; }, 300);
    }
    document.body.classList.remove('cd-lock');
    document.removeEventListener('keydown', onKey, true);
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;

    /* keep Tab inside the panel while it is open */
    var all = panel.querySelectorAll(FOCUSABLE);
    var list = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].offsetParent !== null && !all[i].disabled) list.push(all[i]);
    }
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ---------------- line changes ---------------- */

  function changeLine(line, qty) {
    if (busy) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST', headers: JSON_HEAD,
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(ok)
      .then(function () { return refresh(qty === 0 ? 'Removed from your cart' : 'Cart updated'); })
      .catch(function () { say('Could not update the cart'); })
      .then(function () { busy = false; });
  }

  /* ---------------- wiring ---------------- */

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var cartLink = e.target.closest('.cart-link');
    if (cartLink) { e.preventDefault(); open(cartLink); return; }

    if (e.target.closest('[data-cd-close]')) { e.preventDefault(); close(); return; }
    if (scrim && e.target === scrim) { close(); return; }

    var step = e.target.closest('.cd-qty button, .cd-rm');
    if (step) {
      e.preventDefault();
      changeLine(parseInt(step.getAttribute('data-line'), 10), parseInt(step.getAttribute('data-q'), 10));
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || (form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;

    /* Buy now posts natively so the shopper lands on the checkout, not in the drawer */
    var submitter = e.submitter;
    if (submitter && submitter.value === '/checkout') return;

    e.preventDefault();
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        open(submitter || form);
        say('Added to your cart');
      })
      .catch(function () { form.submit(); });   /* fall back to the plain post */
  });

  if (warrantyBox) {
    warrantyBox.addEventListener('change', function () {
      if (busy) { warrantyBox.checked = !warrantyBox.checked; return; }
      busy = true;
      var wanted = warrantyBox.checked;
      var req = wanted
        ? fetch('/cart/add.js', { method: 'POST', headers: JSON_HEAD,
            body: JSON.stringify({ id: Number(WARRANTY_ID), quantity: 1 }) }).then(ok)
        : getCart().then(function (cart) {
            var at = 0;
            (cart.items || []).forEach(function (it, i) { if (isWarranty(it)) at = i + 1; });
            if (!at) return cart;
            return fetch('/cart/change.js', { method: 'POST', headers: JSON_HEAD,
              body: JSON.stringify({ line: at, quantity: 0 }) }).then(ok);
          });
      req
        .then(function () { return refresh(wanted ? 'Extended warranty added' : 'Extended warranty removed'); })
        .catch(function () { warrantyBox.checked = !wanted; say('Could not change the warranty'); })
        .then(function () { busy = false; });
    });
  }

  /* a page restored from the back/forward cache can hold a stale count */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) getCart().then(function (c) { paintBadge(c.item_count); }).catch(function () {});
  });
})();
